import { render, staticRenderFns } from "./MarketingSegments.vue?vue&type=template&id=bd407cfc&scoped=true"
import script from "./MarketingSegments.vue?vue&type=script&lang=js"
export * from "./MarketingSegments.vue?vue&type=script&lang=js"
import style0 from "./MarketingSegments.vue?vue&type=style&index=0&id=bd407cfc&prod&scoped=true&lang=css"
import style1 from "./MarketingSegments.vue?vue&type=style&index=1&id=bd407cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd407cfc",
  null
  
)

export default component.exports